import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 32px;
  height: 29px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "29",
  "aria-label": "Inloggen"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1525, -25)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1464, 22)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(59, 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4, 3)"
}, /*#__PURE__*/React.createElement("ellipse", {
  strokeWidth: "4",
  cx: "13.9107585",
  cy: "8.85641884",
  rx: "7.00107904",
  ry: "6.85641884"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.821517,28.9846435 C27.821517,21.8700761 21.5934583,16.1025797 13.9107585,16.1025797 C6.22805873,16.1025797 0,21.8700761 0,28.9846435",
  strokeWidth: "4"
}))))))));